<button class="favorite-btn" (click)="toggle()" [disabled]="toggling"
        [title]="status === 1 ? 'Remove from favorites' : 'Add to favorites'">
  <i class="pi" [class.pi-heart-fill]="status === 1" [class.pi-heart]="status !== 1"
     [class.active]="status === 1"></i>
</button>
